/**
 * The height model's person box, in a shape the benchmark can compare.
 *
 * Structural rather than importing MediaPipe's types, so it is testable without
 * loading `@mediapipe/tasks-vision` under Jest.
 */

export interface PersonBox {
  xMin: number;
  yMin: number;
  width: number;
  height: number;
  score: number;
}

interface DetectionLike {
  categories: Array<{ categoryName?: string; score?: number }>;
  boundingBox?: { originX: number; originY: number; width: number; height: number };
}

export function personBoxFrom(detections: DetectionLike[]): PersonBox | null {
  for (let i = 0; i < detections.length; i++) {
    const d = detections[i];
    const c = d.categories && d.categories[0];
    if (!c || c.categoryName !== "person" || !d.boundingBox) continue;
    const b = d.boundingBox;
    return { xMin: b.originX, yMin: b.originY, width: b.width, height: b.height, score: c.score || 0 };
  }
  return null;
}

export function boxIoU(a: PersonBox, b: PersonBox): number {
  const x1 = Math.max(a.xMin, b.xMin);
  const y1 = Math.max(a.yMin, b.yMin);
  const x2 = Math.min(a.xMin + a.width, b.xMin + b.width);
  const y2 = Math.min(a.yMin + a.height, b.yMin + b.height);
  const inter = Math.max(0, x2 - x1) * Math.max(0, y2 - y1);
  const union = a.width * a.height + b.width * b.height - inter;
  return union > 0 ? inter / union : 0;
}
